"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NotNullSymbol = Symbol("not null");
const NotNullIdentifier = { [NotNullSymbol]: true };
const NotUndefinedSymbol = Symbol("not undefined");
const NotUndefinedIdentifier = { [NotUndefinedSymbol]: true };
//# sourceMappingURL=Helpers.js.map